<div class="settings-title">
    <h1 translate="PREFERENCES_TITLE"></h1>
    <div class="settings-title-description" translate="PREFERENCES_TITLE_DESCRIPTION"></div>
</div>

<form [formGroup]="objectivesForm">
    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="LATE_ARRIVALS"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="TIME_WINDOW_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-optimization-preferences-btn-group
                formControlName="timeWindowWeight"
                [disableCriticalPriority]="criticalPrioritySelected && objectivesForm.value.timeWindowWeight !== 6"
                [disableHighPriority]="highPrioritySelected && objectivesForm.value.timeWindowWeight !== 3"
                [disableLowPriority]="threeOrMoreLowPrioritiesSelected && objectivesForm.value.timeWindowWeight !== 1"
                (change)="objectiveChange()"
            ></app-optimization-preferences-btn-group>
        </div>
    </div>
    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="TRAVEL_TIME"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="TRAVEL_TIME_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-optimization-preferences-btn-group
                formControlName="travelTimeWeight"
                [disableCriticalPriority]="criticalPrioritySelected && objectivesForm.value.travelTimeWeight !== 6"
                [disableHighPriority]="highPrioritySelected && objectivesForm.value.travelTimeWeight !== 3"
                [disableLowPriority]="threeOrMoreLowPrioritiesSelected && objectivesForm.value.travelTimeWeight !== 1"
                (change)="objectiveChange()"
            ></app-optimization-preferences-btn-group>
        </div>
    </div>
    <ng-container>
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="VISIT_CONTINUITY"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="VISIT_CONTINUITY_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-optimization-preferences-btn-group
                    formControlName="visitHistoryWeight"
                    [disableCriticalPriority]="criticalPrioritySelected && objectivesForm.value.visitHistoryWeight !== 6"
                    [disableHighPriority]="highPrioritySelected && objectivesForm.value.visitHistoryWeight !== 3"
                    [disableLowPriority]="threeOrMoreLowPrioritiesSelected && objectivesForm.value.visitHistoryWeight !== 1"
                    (change)="objectiveChange()"
                ></app-optimization-preferences-btn-group>
            </div>
        </div>
    </ng-container>
    <div class="setting-container row">
        <div class="col-md-4 setting-label">
            <span translate="OVERQUALIFICATION"></span>
            <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                              popoverText="OVERQUALIFICATION_INFO"></app-info-tooltip>
        </div>
        <div class="col-md-8 setting-value">
            <app-optimization-preferences-btn-group
                formControlName="overqualifiedWeight"
                [disableCriticalPriority]="criticalPrioritySelected && objectivesForm.value.overqualifiedWeight !== 6"
                [disableHighPriority]="highPrioritySelected && objectivesForm.value.overqualifiedWeight !== 3"
                [disableLowPriority]="threeOrMoreLowPrioritiesSelected && objectivesForm.value.overqualifiedWeight !== 1"
                (change)="objectiveChange()"
            ></app-optimization-preferences-btn-group>
            @if (objectivesForm.value.overqualifiedWeight === 3 || objectivesForm.value.overqualifiedWeight === 6) {
                <app-tooltip
                    appCustomPopover
                    placement="left"
                    popoverType="warning"
                    class="overqualification-warning"
                    position="left"
                    popoverText="{{objectivesForm.value.overqualifiedWeight === 3?
                'HIGH_OVERQUALIFICATION_WEIGHT_WARNING' : 'CRITICAL_OVERQUALIFICATION_WEIGHT_WARNING'}}"
                >
                    <ng-container icon>
                        <span class="vismaicon vismaicon-sm vismaicon-filled vismaicon-warning"></span>
                    </ng-container>
                </app-tooltip>
            }
        </div>
    </div>
    @if (rostersPresentInInstance) {
        <div class="setting-container row">
            <div class="col-md-4 setting-label">
                <span translate="SETTINGS_ASSIGN_TASKS_TO_SAME_ROSTER_DEPARTMENT"></span>
                <app-info-tooltip iconSize="sm" appCustomPopover popoverType="warning" placement="right"
                                  popoverText="GROUP_ASSIGN_TASKS_TO_SAME_ROSTER_DEPARTMENT_INFO"></app-info-tooltip>
            </div>
            <div class="col-md-8 setting-value">
                <app-optimization-preferences-btn-group
                    formControlName="rosterPriorityWeight"
                    [disableCriticalPriority]="criticalPrioritySelected && objectivesForm.value.rosterPriorityWeight !== 6"
                    [disableHighPriority]="highPrioritySelected && objectivesForm.value.rosterPriorityWeight !== 3"
                    [disableLowPriority]="threeOrMoreLowPrioritiesSelected && objectivesForm.value.rosterPriorityWeight !== 1"
                    (change)="objectiveChange()"
                ></app-optimization-preferences-btn-group>
            </div>
        </div>
    }
</form>
